var map = {
	"./blog.yml": 53,
	"./cloud.yml": 54,
	"./color.yml": 55,
	"./country.yml": 56,
	"./dio.yml": 57,
	"./doc.yml": 58,
	"./emoji.yml": 59,
	"./git.yml": 60,
	"./icon.yml": 61,
	"./license.yml": 62,
	"./link.yml": 63,
	"./metrics.yml": 64,
	"./people.yml": 65,
	"./soft.yml": 66,
	"./src.yml": 67,
	"./status.yml": 68
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52;